import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip as MuiChip,
  styled,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import { useOrderContext } from "context/OrderContext";
import ExpandMore from "@mui/icons-material/ExpandMore";
import EmptyMessage from "components/EmptyMessage";

const Chip = styled(MuiChip)(() => ({
  fontSize: "unset",
}));

const ContractData: React.FC = () => {
  const order = useOrderContext();

  const isLargeScreen = useMediaQuery((theme: any) => theme.breakpoints.up("md"));
  const [isExpanded, setIsExpanded] = useState(isLargeScreen);
  useEffect(() => setIsExpanded(isLargeScreen), [isLargeScreen]);

  const hasContractDetails =
    order.contractCableLabeling ||
    order.contractSerialNumber ||
    order.contractTheftProtection ||
    order.contractInspection ||
    order.contractDemonstration ||
    order.contractSourceCode ||
    order.contractCheatSheet ||
    order.contractDocumentation ||
    order.contractQrCode;

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      expanded={isExpanded}
      onChange={(_, isExpanded: boolean) => setIsExpanded(!isLargeScreen && isExpanded)}
      sx={(theme) => ({
        [theme.breakpoints.up("md")]: {
          py: 1,
          "& .MuiAccordionSummary-root": {
            minHeight: "unset",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            fontSize: "small",
          },
          "& .MuiAccordionDetails-root": {
            py: 0,
          },
        },
      })}
    >
      <AccordionSummary expandIcon={!isLargeScreen && <ExpandMore />}>
        <Box
          display="flex"
          alignItems="center"
          gap={0.75}
          sx={(theme) => ({
            [theme.breakpoints.up("md")]: { fontSize: "small" },
          })}
        >
          Avtalsinformation
          <Tooltip arrow title="Denna order har avtal som inkluderar listade punkter">
            <HelpIcon color="disabled" fontSize="small" />
          </Tooltip>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ px: 2, pb: 1, pt: isLargeScreen ? 1 : 0 }}>
        {hasContractDetails ? (
          <Box display="flex" flexWrap="wrap" gap={1}>
            {order.contractCableLabeling && <Chip label="Kabelmärkning" />}
            {order.contractSerialNumber && <Chip label="Serienummer" />}
            {order.contractTheftProtection && <Chip label="Stöldmärkning" />}
            {order.contractInspection && <Chip label="Besiktning" />}
            {order.contractDemonstration && <Chip label="Utbildning" />}
            {order.contractSourceCode && <Chip label="Källkod" />}
            {order.contractCheatSheet && <Chip label="Lathund" />}
            {order.contractDocumentation && <Chip label="Dokumentation" />}
            {order.contractQrCode && <Chip label="QR-kod" />}
          </Box>
        ) : (
          <EmptyMessage>Ej angiven</EmptyMessage>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default ContractData;
